import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Homepage } from 'src/app/models/homepage.model';
import { LocationService } from 'src/app/services/location.service';
import { MediaService } from 'src/app/services/media.service';
import { NewsService } from 'src/app/services/news.service';
import { PageService } from 'src/app/services/page.service';

@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.sass'],
  encapsulation: ViewEncapsulation.None,
})
export class HomeComponent implements OnInit {

  pagetitle:string = "MUDICO";
  pagedata: Homepage = new Homepage;
  newsitems:any[] = [];
  vestigingen:any[] = [];
  selectedNewsItem:any;

  constructor(private pages:PageService, private newsService:NewsService, private mediaService:MediaService, private locationService:LocationService) { }

  ngOnInit(): void {
    this.pages.getHome().subscribe(data => {
      this.pagedata = data.data;
    });

    this.newsService.getNieuws().subscribe(data => {
      data.data.forEach((element: any) => {
        let item = element;
        item.icoon = this.mediaService.getMediaItemUrl(item.icoon);
        item.foto = this.mediaService.getMediaItemUrl(item.foto, null);
        this.newsitems.push(item);
      });
      this.selectedNewsItem = this.newsitems[0];
    });

    this.locationService.getVestigingen().subscribe(data => {
      data.data.forEach((element: any) => {
        let item = this.locationService.populateVestiging(element);
        this.vestigingen.push(item);
      });
    })
  }

}
